//imports
import React, { useState, useEffect } from "react";
import {
  Box,
  Link,
  Breadcrumbs,
  Stack,
  Button,
  Grid,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  MenuItem,
  Checkbox,
  InputLabel,
  Select,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externaldeleteApi,
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { ORDER_API_04, ORDER_API_08 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_PENDING,
  CON_STATUS_RETURN,
} from "../../utils/sys/Constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import currencyFormat from "../../utils/common/CurrencyFormat";

function OrderReturn() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const { ORDERCODE } = location.state || {};
  const [orderData, setOrderData] = useState([]);
  const [remarkOptions, setRemarkOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState({});
  const [checkedRows, setCheckedRows] = useState({});
  const [refundChecked, setRefundChecked] = useState({});
  const [additionalData, setAdditionalData] = useState(null);
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmReturnOrder = async () => {
    setOpenDialog(false);
    await handleReturnOrder(); // Call the return order function
  };

  const handleRefundCheckboxChange = (event, idno) => {
    setRefundChecked((prev) => ({
      ...prev,
      [idno]: event.target.checked ? "Y" : "X", // Store "Y" if checked, "X" if unchecked
    }));
  };
  // fetch
  useEffect(() => {
    const fetchOrderData = async () => {
      setIsLoading(true);
      try {
        const orderResult = await externalgetApi(ORDER_API_04, "get", {
          ORDERCODE,
        });
        console.log("API response:", orderResult);

        const filteredData = Object.values(orderResult["1"])
          .flat()
          .filter((item) => item && item.MENUNAME);
        setOrderData(filteredData);

        // Set additional data from "set[2]"
        const additional = orderResult["2"];
        setAdditionalData(additional);

        const remarks = orderResult["3"];
        setRemarkOptions(remarks);
      } catch (err) {
        console.error("Error fetching order data:", err);
        setError("Failed to load order data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrderData();
  }, [ORDERCODE]);

  const handleReturnOrder = async () => {
    // Filter out items where IDNO is valid (if needed) or use the entire orderData
    const returnOrderData = orderData.filter((item) => checkedRows[item.IDNO]);

    // Create payload for return order grouped by IDNO
    const payload = {
      returnorderdt: returnOrderData.map((item) => ({
        idno: item.IDNO,
        seqid: item.SEQID,
        ordercode: ORDERCODE,
        menucatcode: item.MENUCATCODE,
        menucode: item.MENUCODE,
        odremarkcode: selectedRemarks[item.IDNO] || 0, // Use selected remark
        qty: item.QTY,
        rate: item.RATE,
        amount: item.QTY * item.RATE,
        isrefund: refundChecked[item.IDNO] || "X",
        sts: "R", // Set status as needed
      })),
      ordercode: String(ORDERCODE),
      remark: "Return/Refund", // Update based on input
      returndate: new Date().toISOString(),
      sts: "R",
      enuser: USERNAME,
    };

    try {
      // Make the API call to submit the return order data
      const response = await externalpostApi(ORDER_API_04, payload);

      // If the request is successful, show the success snackbar
      setSnackbarMessage("Order return submitted successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      // In case of failure, show the error snackbar
      console.error("Error returning order:", error);
      setSnackbarMessage("Failed to submit order return");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };
  //handlers
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setError(null);
  };

  const gotToView = () => {
    navigate("/orderlist");
  };
  const handleRemarkChange = (event, idno) => {
    setSelectedRemarks((prev) => ({
      ...prev,
      [idno]: event.target.value,
    }));
  };

  const handleCheckboxChange = (event, idno) => {
    setCheckedRows((prev) => ({
      ...prev,
      [idno]: event.target.checked,
    }));
  };

  const getRemarkText = (idNo) => {
    const matchingRemarks = additionalData
      ? additionalData.filter((item) => item.ORDERITEMCODE === idNo)
      : [];

    // Join all remarks for the matched items
    return matchingRemarks.length > 0
      ? matchingRemarks.map((item) => item.REMARK).join("; ")
      : "No Remark";
  };

  // const getremarkid = (idNo) => {
  //   console.log('IDNO',idNo);
  //   const matchingRemarks = additionalData
  //     ? additionalData.filter((item) => item.ORDERITEMCODE === idNo)
  //     : [];
  //   console.log('aaaaaaaaa',additionalData);
  //   //console.log('zzzzz',(additionalData[0].ODREMARKCODE));
  //   // Join all remarks for the matched items
  //   //return additionalData[0].ODREMARKCODE;
  // };

  const getremarkid = (idno) => {
    const matchingRemarks = additionalData
      ? additionalData.filter((item) => item.ORDERITEMCODE === idno)
      : [];

    return matchingRemarks.length > 0 ? matchingRemarks[0].ODREMARKCODE : "";
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" href="/">
                  Home
                </Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">Order return</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AddStyledBox}>
        <Toolbar
          sx={{
            maxWidth: "100%",
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            background: theme.palette.background.paper,
            marginTop: { xs: "170px", md: "155px" },
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{ color: theme.palette.text.primary, flex: "1 1 100%", ml: 1 }}
          >
            Order Number: {ORDERCODE}
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="flex-end" p={2}>
            <Button
              variant="contained"
              onClick={handleOpenDialog}
              sx={{
                background: theme.palette.primary.main,
                color: theme.palette.text.buttontxt,
                textTransform: "capitalize",
                width: "180px",
              }}
            >
              Return / refund order
            </Button>
          </Stack>
        </Toolbar>

        {isLoading ? (
          <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
        ) : (
          <TableContainer component={Paper} sx={styles.VI_ViewStyledPaper}>
            <Table sx={{ minWidth: 650 }} aria-label="order table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Menu Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Quantity
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">
                    Rate
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Action
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Remark
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderData.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.MENUNAME}</TableCell>
                    <TableCell align="center">{item.QTY}</TableCell>
                    <TableCell align="right">
                      {currencyFormat(item.RATE)}
                    </TableCell>
                    <TableCell align="center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkedRows[item.IDNO] || false}
                            onChange={(event) =>
                              handleCheckboxChange(event, item.IDNO)
                            }
                            disabled={item.STS === CON_STATUS_RETURN} // Disable if sts
                          />
                        }
                        label="Return"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={refundChecked[item.IDNO] === "Y"}
                            onChange={(event) =>
                              handleRefundCheckboxChange(event, item.IDNO)
                            }
                            disabled={
                              item.STS === CON_STATUS_ACTIVE &&
                              item.STS === CON_STATUS_RETURN
                            } // Disable if sts is
                          />
                        }
                        label="Refund"
                      />
                    </TableCell>
                    <TableCell sx={{ width: "30%" }}>
                      <FormControl fullWidth>
                        <InputLabel>Reason</InputLabel>
                        <Select
                          label="Reason"
                          fullWidth
                          value={
                            getremarkid(item.IDNO) || selectedRemarks[item.IDNO]
                          }
                          onChange={(event) =>
                            handleRemarkChange(event, item.IDNO)
                          }
                        >
                          {remarkOptions.map((remark) => (
                            <MenuItem
                              key={remark.ODREMARKCODE}
                              value={remark.ODREMARKCODE}
                            >
                              {remark.REMARK}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <DialogTitle id="confirmation-dialog-title">
          Confirm Return Order
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to submit the return/refund order ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            variant="outlined"
            sx={{
              textTransform: "capitalize",
              borderRadius: 2,
              width: "100px",
              px: 3,
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmReturnOrder}
            sx={{
              background: theme.palette.primary.main,
              color: theme.palette.text.buttontxt,
              textTransform: "capitalize",
              borderRadius: 2,
              width: "100px",
              px: 3,
              "&:hover": {
                background: theme.palette.primary.main,
              },
            }}
            color="primary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default OrderReturn;
